const RPC_URL_KEY = 'cohort-rpc-url';

export function getStoredRpcUrl(): string | null {
  try {
    const value = localStorage.getItem(RPC_URL_KEY);
    return value && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
}

export function setStoredRpcUrl(url: string): void {
  const trimmed = url.trim();
  if (trimmed) {
    localStorage.setItem(RPC_URL_KEY, trimmed);
  } else {
    localStorage.removeItem(RPC_URL_KEY);
  }
}

export function clearStoredRpcUrl(): void {
  localStorage.removeItem(RPC_URL_KEY);
}
